﻿'use strict';

angular.module('ntmApp').factory('DragFromResourcePool', ['DraggingObject', 'DailyPlanService', 'FlashService', 'DailyPlanConfirmationService', 'WatchDndTargetsService', 'ActivitiesGroupSkillsValidator','ActivitySkillsValidator',
    function (DraggingObject, DailyPlanService, FlashService, DailyPlanConfirmationService, WatchDndTargetsService, ActivitiesGroupSkillsValidator,ActivitySkillsValidator) {

    function DragFromResourcePool(view) {

        var self = this;

        var onStartDraggingEvent = null;
        var onEndDraggingEvent = null;

        var DragNDropMessageType = {
            SomeUnchangeableActivities: 0,
            AllUnchangeableActivities: 1,
            AvailableTime: 2,
            StaffSkills: 3,
            DropEvent: 4,

            allowContinue: function (messageType) {
                return messageType === this.AvailableTimeOff ||
                       messageType === this.AvailableTimeOn ||
                       messageType === this.StaffSkillsOff ||
                       messageType === this.StaffSkillsOn ||
                       messageType === this.SomeUnchangeableActivities;
            }
        };



        self.startDragging = function (staff) {

            if (onStartDraggingEvent) {
                var allowed = onStartDraggingEvent(staff);

                if (allowed) {
                    self.DraggingObject.setDraggingObject(staff);
                }
            }
        };

        self.drag = function (staff) {

            var draggingInfo = view.getInfoForDraggingAction();

            draggingInfo.personId = staff.personId;
            draggingInfo.personName = staff.staffName;
            draggingInfo.availableTime = staff.available;
            draggingInfo.allTargetStaffSkill = staff.allTargetStaffSkill;

            if (draggingInfo.isSingleActivity) {
                proccessDragAndDropEventFromResourcePoolToGridRow(draggingInfo, DragNDropMessageType.AvailableTime);

            } else {
                if (draggingInfo.changeableHours === 0) {
                    proccessDragAndDropEventFromResourcePool(draggingInfo, DragNDropMessageType.AllUnchangeableActivities);
                } else {
                    proccessDragAndDropEventFromResourcePool(draggingInfo, DragNDropMessageType.SomeUnchangeableActivities);
                }
            }
        };

        self.endDragging = function () {
            if (!WatchDndTargetsService.DKeyPressed) {
                self.DraggingObject.releaseDraggingObject();
            }
        };

        self.onStartDragging = function (event) {
            onStartDraggingEvent = event;
            return self;
        };

        self.onEndDragging = function (event) {
            onEndDraggingEvent = event;
            return self;
        };
        function proccessDragAndDropEventFromResourcePool(dragInformation, dragType) {

            var moveFromResourcePool;

            if (dragInformation.activities.filter(function (item) { return item.assignmentId === null; }).length === 0 && dragInformation.isExistingAssignments === false)
            {
                if (dragInformation.groupName) {
                    FlashService.Error("No un-assigned activities in this set. If you wish to replace existing assignments, please check the Replace Existing Assignments checkbox in the Resource Pool.", true);
                }
                else {
                    FlashService.Error("No un-assigned activities on the room. If you wish to replace existing assignments, please check the Replace Existing Assignments checkbox in the Resource Pool.", true);
                }

                view.defaultDndTargets();
                return;
            } 


            if (DragNDropMessageType.AllUnchangeableActivities === dragType && dragInformation.changeableHours === 0 && dragInformation.isExistingAssignments) {
                FlashService.Error("The currently assigned staff have already started or completed every activity in the room. Nothing can be reassigned.", true);

                view.defaultDndTargets();
                return;
            }

            if (DragNDropMessageType.SomeUnchangeableActivities === dragType && dragInformation.totalHours !== dragInformation.changeableHours && dragInformation.isExistingAssignments) {
  

                 moveFromResourcePool = function () { dragType = DragNDropMessageType.AvailableTime; proccessDragAndDropEventFromResourcePool(dragInformation, dragType); };

                    DailyPlanConfirmationService.MoveFromResourcePool("Some activities have already been started and/or completed by the currently assigned staff. Only the activities that are not started will be reassigned.")
                                           .Yes(moveFromResourcePool)
                                           .No(function () { view.defaultDndTargets(); })
                                           .Ask();
                    return;
            } else if (dragType < DragNDropMessageType.AvailableTime) {
                dragType = DragNDropMessageType.AvailableTime;
            }

           if (dragType === DragNDropMessageType.AvailableTime) {

               var messageText = "";

               if (dragInformation.isExistingAssignments === false && dragInformation.unAssignedHours > dragInformation.availableTime) {
                   if (dragInformation.groupName) {
                       messageText = "Assigning {0} to this set of un-assigned activities will over-allocate them by {1}hrs.";
                   }
                   else {
                       messageText = "Assigning {0} to this room’s un-assigned activities will over-allocate them by {1}hrs.";
                   }

                   messageText = messageText.format(dragInformation.personName, parseFloat(dragInformation.unAssignedHours - dragInformation.availableTime).toFixed(2));

               } else if (dragInformation.isExistingAssignments && dragInformation.changeableHours > dragInformation.availableTime)
               {
                   if (dragInformation.groupName) {
                       messageText = "Assigning {0} to this set of activities will over-allocate them by  {1}hrs.";
                   }
                   else {
                       messageText = "Assigning {0} to this room’s un-assigned activities will over-allocate them by {1}hrs.";
                   }

                   messageText = messageText.format(dragInformation.personName, parseFloat(dragInformation.changeableHours - dragInformation.availableTime).toFixed(2));
               }


                moveFromResourcePool = function () { dragType = DragNDropMessageType.StaffSkills; proccessDragAndDropEventFromResourcePool(dragInformation, dragType); };

               if (messageText) {
                   DailyPlanConfirmationService.MoveFromResourcePool(messageText)
                                          .Yes(moveFromResourcePool)
                                          .No(function () {
                                              view.defaultDndTargets();
                                          })
                                          .Ask();
                   return;
               }
           }
           if (dragType < DragNDropMessageType.StaffSkills) {
               dragType = DragNDropMessageType.StaffSkills;
           }


           if (dragType === DragNDropMessageType.StaffSkills) {

               var skillsValidator = new ActivitiesGroupSkillsValidator(dragInformation.activities, {}, { personId: dragInformation.personId, staffName: dragInformation.personName }, dragInformation.allTargetStaffSkill, dragInformation.isExistingAssignments);

               if (skillsValidator.isValid()) {
                   dragType = DragNDropMessageType.DropEvent;
               } else {
                   moveFromResourcePool = function () { dragType = DragNDropMessageType.DropEvent; proccessDragAndDropEventFromResourcePool(dragInformation, dragType); };

                   DailyPlanConfirmationService.MoveFromResourcePool("{0} is not qualified for the following un-assigned activities in this set: ".format(dragInformation.personName), skillsValidator.getNonValidActivitiesArray().sort())
                                              .Yes(moveFromResourcePool)
                                              .No(function () { view.defaultDndTargets(); })
                                              .Ask();
               }

           } else if (dragType < DragNDropMessageType.DropEvent) {
               dragType = DragNDropMessageType.DropEvent;
           }

 
           if (dragType === DragNDropMessageType.DropEvent) {

               var loadingModal = FlashService.Loading();

               var request = {
                   facilityCode: dragInformation.facilityCode,
                   roomNumber: dragInformation.roomNumber,

                   personId: dragInformation.personId,
                   personName: dragInformation.personName,
                   date: dragInformation.date,
                   isExistingAssignments: dragInformation.isExistingAssignments,

                   groupName: dragInformation.groupName,
                   ccrackId: dragInformation.ccrackId
               };

               DailyPlanService.DragFromResourcePoolToActivitiesGrid(request).then(function (result) {
                   loadingModal.dismiss();
                   view.defaultDndTargets();
                   FlashService.Success(result.data.message);
               });

           }

        }

        function proccessDragAndDropEventFromResourcePoolToGridRow(dragInformation, dragType) {
            var moveFromResourcePool;

            if (dragType === DragNDropMessageType.AvailableTime) {

                var messageText = "";
				
				var totalHours = dragInformation.totalHours/60;

                if ( totalHours > dragInformation.availableTime) {

                    messageText = "Assigning {0} to this activity will over-allocate them by {1}hrs.";

                    messageText = messageText.format(dragInformation.personName, Math.abs(parseFloat(dragInformation.availableTime - totalHours)).toFixed(2));

                } 
                moveFromResourcePool = function () { dragType = DragNDropMessageType.StaffSkills; proccessDragAndDropEventFromResourcePoolToGridRow(dragInformation, dragType); };

                if (messageText) {
                    DailyPlanConfirmationService.MoveStaffFromResourcePoolToRoomActivityRow(messageText)
                                            .Yes(moveFromResourcePool)
                                            .No(function () { view.defaultDndTargets(); })
                                            .Ask();
                    return;
                }
            } else if (dragType < DragNDropMessageType.StaffSkills) {
                dragType = DragNDropMessageType.StaffSkills;
            }



            if (dragType === DragNDropMessageType.StaffSkills) {

                var skillsValidator = new ActivitySkillsValidator( {  speciesId: dragInformation.speciesId, speciesName: dragInformation.speciesName, activityId: dragInformation.activityId, activity: dragInformation.activity }, {}, { personId: dragInformation.personId, staffName: dragInformation.personName }, dragInformation.allTargetStaffSkill);

                if (skillsValidator.isValid()) {
                    dragType = DragNDropMessageType.DropEvent;
                } else {
                    moveFromResourcePool = function () { dragType = DragNDropMessageType.DropEvent; proccessDragAndDropEventFromResourcePoolToGridRow(dragInformation, dragType); };

                    DailyPlanConfirmationService.MoveStaffFromResourcePoolToRoomActivityRow("{0} is not qualified for this activity.".format(dragInformation.personName))
                                               .Yes(moveFromResourcePool)
                                               .No(function () { view.defaultDndTargets(); })
                                               .Ask();
                }

            } else if (dragType < DragNDropMessageType.DropEvent) {
                dragType = DragNDropMessageType.DropEvent;
            }

 
            if (dragType === DragNDropMessageType.DropEvent) {

                var loadingModal = FlashService.Loading();

                var request = {
                    facilityCode: dragInformation.facilityCode,
                    roomNumber: dragInformation.roomNumber,
                    date: dragInformation.date,
                    scheduleId: dragInformation.scheduleId,
                    personId: dragInformation.personId,
                    personName: dragInformation.personName,
                    activityName: dragInformation.activityName
                };

                DailyPlanService.DragFromResourcePoolToActivitiesGridRow(request).then(function (result) {
                    loadingModal.dismiss();
                    FlashService.Success(result.data.message);
                });



                }
            
        }

        function initialize() {
            self.DraggingObject = new DraggingObject();
            self.DraggingType = "DRAG_FROM_RESOURCE_POOL";
        }

        initialize();

    }

    return (DragFromResourcePool);

}]);